import { Button } from 'antd';
import React from 'react';
import { ContentWrapper } from '../../components/content_wrapper/content_wrapper';
import { LinkButton } from '../../components/link_button/link_button';
import { ScrollToTop } from '../../components/scroll_to_top/scroll_to_top';
import { SEO } from '../../components/seo/seo';
import { RoutePaths } from '../../routes';
import SvgBeefIcon from '../jack_links_page/beef-icon';
import SvgCarryAndPackIcon from '../jack_links_page/carry-icon';
import SvgProteinIcon from '../jack_links_page/protein-icon';
import omniaLogo from '../jack_links_page/svg/logo.svg';
import SvgSmokeMeatIcon from './smoked_meat_icon';
import jerkyImage from './wild_river_jerky.png';
import wildRiverLogo from './wild_river_logo.png';
import mac from './wild_river_mac.png';
import styles from './wild_river_page.less';
import promoPhoto from './wild_river_photo.jpg';

const WildRiverPage = () => {
  return (
    <ScrollToTop>
      <SEO title="Free Wild River Beef Jerky With Your Omnia Order" />
      <header className={styles.hero}>
        <ContentWrapper>
          <div className={styles.graphicLogo}>
            <a href="https://www.wildriverjerky.com ">
              <img src={wildRiverLogo} alt="Wild River Logo" />
            </a>
          </div>
        </ContentWrapper>
        <div className={styles.heroContent}>
          <ContentWrapper>
            <div className={styles.rowContainer}>
              <div className={styles.textContainer}>
                <div className={styles.text}>
                  <h1 className={styles.mainHeader}>Free Wild River Jerky With Your Omnia Order</h1>
                  <p className={styles.mainParagraph}>
                    While supplies last, you'll get a FREE package of Wild River beef jerky with
                    your order. Wild River is an authentic slow dried, thinner, rugged jerky with
                    rich flavor made the way it should be.
                  </p>
                </div>
              </div>
              <div className={styles.img}>
                <img src={promoPhoto} alt="Promo Photo" />
              </div>
            </div>
            <div className={styles.row__reverse}>
              <div className={styles.text}>
                <h3 className={styles.reverseHeader}>Get Your Free Wild River Jerky</h3>
                <p className={styles.reverseParagraph}>
                  Omnia and Wild River are bringing you a bonus in your next order. While supplies
                  last, Omnia customers will get a free package of Wild River slow dried beef jerky
                  to take on your next outing. Available for orders of $50 and up. Find this limited
                  time offer in your cart and select your preferred flavor before you check out.
                </p>
                <div className={styles.shopNow}>
                  <LinkButton to={RoutePaths.SHOP}>Shop Now</LinkButton>
                </div>
              </div>
              <div className={styles.macContainer}>
                <img className={styles.heroMac} src={mac} alt="Mac image" />
              </div>
            </div>
          </ContentWrapper>
        </div>

        <section className={styles.listContainer}>
          <div className={styles.list}>
            <div className={styles.listItem}>
              <div className={styles.icon}>
                <SvgBeefIcon />
              </div>
              <span className={styles.span}>Made in the USA with 100% beef</span>
            </div>
            <div className={styles.listItem}>
              <div className={styles.icon}>
                <SvgProteinIcon />
              </div>
              <span className={styles.span}>High in protein and zero sugar</span>
            </div>
            <div className={styles.listItem}>
              <div className={styles.icon}>
                <SvgCarryAndPackIcon />
              </div>
              <span className={styles.span}>Easy to pack snacking for long trips</span>
            </div>
            <div className={styles.listItem}>
              <div className={styles.icon}>
                <SvgSmokeMeatIcon />
              </div>
              <span className={styles.span}>Slow smoked for a longer, satisfying chew</span>
            </div>
          </div>
        </section>
      </header>

      <section className={styles.infoSection}>
        <ContentWrapper>
          <div className={styles.info}>
            <span className={styles.blurb}>
              Perfect for savoring the outdoors. Wild River makes authentic old fashioned jerky. The
              resulting snack takes longer to make, takes time to chew and will take you back to the
              traditional flavor you remember.
            </span>
            <div className={styles.graphicJerky}>
              <img src={jerkyImage} alt="beef jerky image" />
            </div>
          </div>
          <div className={styles.linkContainer}>
            <h3>Visit Wild River and Save</h3>
            <p>
              For more on Wild River snacks including purchase and subscription options, visit{' '}
              <a href="https://www.wildriverjerky.com">WildRiverJerky.com</a>. Save 50% on your
              jerky order with code OMNIA50.
            </p>
            <Button
              className={styles.actionButton}
              onClick={() => {
                location.href = 'https://www.wildriverjerky.com';
              }}
            >
              Visit Wild River
            </Button>
          </div>
        </ContentWrapper>
      </section>

      <section className={styles.footerContainer}>
        <ContentWrapper>
          <div className={styles.footer}>
            <h3 className={styles.footerHeader}>BROUGHT TO YOU BY</h3>
            <img className={styles.logo} src={omniaLogo} alt="Omnia Logo" />
            <span className={styles.aboutOmnia}>
              Omnia combines a massive online inventory with tools to help you find just the right
              gear. Local angler fishing reports to power recommendations just right for your lake,
              species and technique.
            </span>
          </div>
        </ContentWrapper>
      </section>
    </ScrollToTop>
  );
};

export default WildRiverPage;
